/** Eine Zeitangabe, wie ein Mensch sie liest. */
export function vorWieLange(zeitpunkt: string | null): string {
  if (zeitpunkt === null) return '—';
  const sekunden = Math.max(0, Math.round((Date.now() - new Date(zeitpunkt).getTime()) / 1000));
  if (sekunden < 60) return `vor ${sekunden} s`;
  if (sekunden < 3600) return `vor ${Math.round(sekunden / 60)} min`;
  if (sekunden < 86_400) return `vor ${Math.round(sekunden / 3600)} h`;
  return new Date(zeitpunkt).toLocaleString('de-DE');
}

export function genau(zeitpunkt: string | null): string {
  return zeitpunkt === null ? 'noch nie' : new Date(zeitpunkt).toLocaleString('de-DE');
}
